import { GameStatus } from '../generated/graphql'

const getGameStatusLabelColor = (type: GameStatus = GameStatus.Draft) => {
  switch (type) {
    case GameStatus.Draft:
      return '#656565'
    case GameStatus.Live:
      return '#39A935'
    case GameStatus.Finished:
      return '#E30613'
    case GameStatus.Anticipation:
      return '#F15A29'
    case GameStatus.Sustain:
      return '#00B2E8'
    default:
      return '#656565'
  }
}

export default getGameStatusLabelColor
